import * as React from 'react';
import styled from 'styled-components';

import { SingleSelect } from '@xing-com/menu';
import { ProfileImage } from '@xing-com/profile-image';
import { ProfileInfo } from '@xing-com/profile-info';
import { spaceM, spaceS, xdlColorHover } from '@xing-com/tokens';
import { Headline, Meta } from '@xing-com/typography';

import type { MentionUser, handleMentionSelectionType } from './types';

export type MentionableUserProps = {
  index: number;
  mapIndex: number;
  onMouseDown: handleMentionSelectionType;
  user: MentionUser;
};

export const MentionableUser: React.FC<MentionableUserProps> = ({
  index,
  mapIndex,
  onMouseDown,
  user,
}) => {
  const userRef = React.useRef<HTMLDivElement>(null);
  const { displayName, isMentionable, occupationOrg, userId, profileImage } =
    user;

  React.useEffect(() => {
    if (mapIndex === index)
      userRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
  }, [index, mapIndex]);

  return (
    <div ref={userRef}>
      <StyledSingleSelect
        $selected={mapIndex === index}
        disabled={!isMentionable}
        ellipsis
        onMouseDown={(e) => {
          e.preventDefault();
          onMouseDown(user);
        }}
        type="button"
        data-qa={`mentionable-user-${index}`}
      >
        <StyledProfileInfo
          key={userId}
          profileImage={
            <ProfileImage
              profileName={displayName}
              size="xsmall"
              src={profileImage}
            />
          }
        >
          <Headline noMargin size="medium">
            {displayName}
          </Headline>
          <Meta noMargin size="small">
            {occupationOrg}
          </Meta>
        </StyledProfileInfo>
      </StyledSingleSelect>
    </div>
  );
};

const StyledProfileInfo = styled(ProfileInfo)`
  padding: 0 !important;
  max-width: 100%;
  text-align: left;
`;

const StyledSingleSelect = styled(SingleSelect)<{ $selected: boolean }>`
  padding: ${spaceM} ${spaceS} !important;
  ${({ $selected }) => $selected && `background-color: ${xdlColorHover};`}
`;
